import { AppThunk } from '../../../../../../store/types';
import { UserTranslateLangEffects } from '../../../../../../effects/userTranslateLangEffects';
import { isShowTranslations } from '../../../../../../store/general/selectors';
import { setShowTranslationsAction } from '../../../../../../store/general/actions';

export class PhraseTranslationSettingsEvents {

	public static onSort(langCodes: string[]): AppThunk {
		return (
			dispatch,
			getState
		) => {
			UserTranslateLangEffects.sortLangs(langCodes);
		}
	}

	public static onToggleShowTranslations(): AppThunk {
		return (
			dispatch,
			getState,
		) => {
			const showTranslations = isShowTranslations(getState());
			dispatch(setShowTranslationsAction(!showTranslations));
		}
	}

}